import EnhancedCreatePetition from "../../components/petitions/CreatePetition/EnhancedCreatePetition";

const CreatePetitionPage = () => {
  return <EnhancedCreatePetition />;
};

export default CreatePetitionPage;
